"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyDietOptions = void 0;
var graphql_api_admin_1 = require("@fdha/graphql-api-admin");
Object.defineProperty(exports, "StudyDietOptions", { enumerable: true, get: function () { return graphql_api_admin_1.StudyDietOptions; } });
